import { types } from "../types/types";
const intitalState = {
  allProducts: [],
  readyToOrderProducts: [],
};

const productsReducer = (state = intitalState, action) => {
  switch (action.type) {
    case types.CHANGE_PRODUCTS:
      return {
        ...state,
        allProducts: action.payload,
      };
    case types.CHANGE_R2O_PRODUCTS:
      return {
        ...state,
        readyToOrderProducts: action.payload,
      };
    default:
      return { ...state };
  }
};

export default productsReducer;
